import { defineMessages } from 'react-intl'

export const network = defineMessages({
  title: {
    id: 'network.title',
    description: 'Main title name for Network AI',
    defaultMessage: 'Smart Network',
  },
  titleName: {
    id: 'network.titleName',
    description: 'Main title + name for Network AI',
    defaultMessage: 'Smart Network Name',
  },
  addTitle: {
    id: 'network.addTitle',
    description: 'Add title for Network AI',
    defaultMessage: 'Add New Smart Network',
  },
  backNetworkAI: {
    id: 'network.backNetworkAI',
    description: 'Text for return to NetworkAI Link',
    defaultMessage: 'Back to Smart Network',
  },
  backNetworkWLANs: {
    id: 'network.backNetworkWLANs',
    description: 'Text for return to NetworkAI Link',
    defaultMessage: 'Back to WLANs',
  },
  networkClients: {
    id: 'network.networkClients',
    description: 'Title for Network Clients',
    defaultMessage: 'Network Clients',
  },
  wlans: {
    id: 'network.wlans',
    description: 'Title for Network WLANs',
    defaultMessage: 'WLANs',
  },
  accessPoints: {
    id: 'network.accessPoints',
    description: 'Title for Access Points',
    defaultMessage: 'Access Points',
  },
  radioConfig: {
    id: 'network.radioConfig',
    description: 'Radio configuration button text',
    defaultMessage: 'Radio Configuration',
  },
  addWlan: {
    id: 'network.addWlan',
    description: 'Add new WLAN button text',
    defaultMessage: 'Add New WLAN',
  },
  introMessage: {
    id: 'network.introMessage',
    description: 'You dont have Smart Network yet intro text',
    defaultMessage:
      'This home does not yet have a Savant Smart Network deployed. This feature is compatible with all Mist products from Juniper Networks. To purchase compatible networking equipment, please visit the Savant Store or contact your local Savant distributor for availability.',
  },
})
